module.exports = "/_next/static/images/buc-2x-62f9504905a3c35ab5b8b636cd50815a.jpg.webp";